import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { ConfigurationService, LoggerService, SecurityService } from 'saker-core';
import { ProjectDTO } from '../Protocol/project.dto';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  constructor(
    private configuration: ConfigurationService,
    private http: HttpClient,
    private logger: LoggerService,
    private security: SecurityService
  ) { }

  //   function getData(response) {
  //     return response.data;
  // }

  // function reject(response) {
  //     if (response && response.data) {
  //         if (response.data.Message) {
  //             return $q.reject(response.data.Message);
  //         }
  //         else {
  //             return $q.reject(response.data);
  //         }
  //     }
  //     else {
  //         return $q.reject('Service Unavailable');
  //     }
  // }

  getProjects() {
    let url = this.configuration.CONFIG.BASE_URL + '/dsm/projects';

    return this.http.get<ProjectDTO[]>(url, { withCredentials: true }).pipe(
      catchError(error => this.logger.handleError(error)));

    // return $http.get(url, config)
    //   .then(getData)
    //   .catch(reject);

  }

  getProject(id:string) {

    console.log("using id")
    console.log(id)

      let url = this.configuration.CONFIG.BASE_URL + "/dsm/project/" + id;

      return this.http.get<ProjectDTO>(url, { withCredentials: true }).pipe(
        catchError(error => this.logger.handleError(error)));
  
      // return $http.get(url, config)
      //     .then(getData)
      //     .catch(reject);
  }
}
